import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { validateConfig } from '@angular/router/src/config';
declare var toastr;

@Component({
  selector: 'app-user-config',
  templateUrl: './user-config.component.html',
  styleUrls: ['./user-config.component.css'],
  providers: [GeneralService]
})
export class UserConfigComponent implements OnInit {
  user: any = {};
  

  constructor(private router: Router, private _gs: GeneralService) {
    this.user = JSON.parse(localStorage.getItem('u'));
    this._gs.getDatosUsuarioById(this.user.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.user = result.data; }
        else { this.user = {}; }
      });
  }

  ngOnInit() {
  }


  savePass() {
    if (this.valid()) {
      this._gs.postUserUpdatePass(this.user).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.router.navigate(['/inicio']);
            toastr.success('Contraseña actualizada exitosamente.');
          }
        });
    }    
  }

  valid() {
    let res = true;
    if ((this.user.password) && this.user.password2) {
      if (this.user.password.toString().trim().length < 6) {
        res = false;
        toastr.warning('Ingrese una contraseña que tenga al menos 6 caracteres.');
      }
      if (this.user.password != this.user.password2) {
        res = false;
        toastr.warning('Las contraseñas no coinciden...');
      }
    }
    else {
      res = false;
    }
    return res;
  }
}
